import React, { useContext, useState } from "react";
import { ThemeContext } from "./ThemeProvider";
import {MoonOutlined, SunOutlined} from "@ant-design/icons";
import {Switch} from "antd";

const ThemeSwitcher = () => {
    const themeMode = useContext(ThemeContext);

    const [checked, setChecked] = useState(themeMode.isDarkMode);

    const handleThemeChange = () => {
        setChecked(!checked);
        themeMode.toggleTheme();
    };


    return (
        <>
            <Switch style={
                {
                    
                }
            }
                    checkedChildren={<SunOutlined />}
                    unCheckedChildren={<MoonOutlined />}
                    defaultChecked={checked}
                    onChange={handleThemeChange}
            />
        </>
    );
};

export default ThemeSwitcher;
